import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function BaseBreadcrumbs({ sequenzaRoutes }) {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{mt:7,mb:3}}>
      {sequenzaRoutes.map((route, index) => {
        const isLast = index === sequenzaRoutes.length - 1;

        if (route.pathAssoluto && !isLast) {
          return (
            <Link
              key={index}
              color="primary"
              href={route.pathAssoluto}
              underline="always"
            >
              {route.label}
            </Link>
          );
        }

        // ultimo elemento o senza path → testo
        return (
          <Typography key={index} color="text.primary" >
            {route.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
}